import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 11a1 1 0 1 1 -1 1.013a1 1 0 0 1 1 -1v-.013","key":"svg-0"}],["path",{"d":"M21 11a1 1 0 1 1 -1 1.013a1 1 0 0 1 1 -1v-.013","key":"svg-1"}],["path",{"d":"M8 12h8","key":"svg-2"}],["path",{"d":"M13 9l3 3l-3 3","key":"svg-3"}]]

const IconBrandCitymapper = createReactComponent('outline', 'brand-citymapper', 'BrandCitymapper', __iconNode);

export default IconBrandCitymapper;